import React from 'react';
import { Button } from 'rsuite';

import './styles.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').ButtonProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomButton({ color, children, ...rest }) {
  const { theme } = useCustomTheme();
  return (
    <Button
      {...rest}
      className="custom-button"
      appearance={rest.appearance ?? 'primary'}
      style={{
        ...rest.style,
        '--button-primary-color': color ?? theme.colors.primary,
      }}
    >
      {children}
    </Button>
  );
}
